import { PessoaService } from '../../pessoa.service';
import { Tecnico } from './../tecnico';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { SwalComponent } from '@toverux/ngx-sweetalert2';
import { SYSCONF_SIGLA } from 'src/app.api';
@Component({
	selector: 'app-tecnico-detail',
  	templateUrl: './tecnicoDetail.component.html',
  	styleUrls: ['./tecnicoDetail.component.scss']
})

export class TecnicoDetailComponent implements OnInit{
	
	@ViewChild('Swal') public swal:SwalComponent; 
	public message:string = '';
	detailForm: FormGroup;
	tecnico: Tecnico;
	tecnico_id:number;
	thumb:string = '';
	pessoa_id:number;
	enderecos:object = new Array();
	telefones:object = new Array();
	idiomas:object = new Array();
	contasBancarias:object = new Array();
	sigla = SYSCONF_SIGLA;
	anexos: any;
	acesso = new Array();
	constructor(private pessoaService: PessoaService, private activatedRoute: ActivatedRoute,private formBuilder: FormBuilder){
		this.detailForm = this.formBuilder.group({
			id: this.formBuilder.control(0),
			estrangeiro: this.formBuilder.control('N'),
			passaporte: this.formBuilder.control(''),
			passaporte_dt_validade: this.formBuilder.control(''),
			cpf: this.formBuilder.control(''),
			dt_nascimento: this.formBuilder.control(''),
			primeiro_nome: this.formBuilder.control(''),
			ultimo_nome: this.formBuilder.control(''),
			nome_completo: this.formBuilder.control(''),
			apelido: this.formBuilder.control(''),
			email: this.formBuilder.control(''),
			nacionalidade: this.formBuilder.control(''),
			naturalidade: this.formBuilder.control(''),
			status: this.formBuilder.control('A'),
			website: this.formBuilder.control(''),
			genero_id: this.formBuilder.control(''),
			rg: this.formBuilder.control(''),
			rg_dt_emissao: this.formBuilder.control(''),
			rg_emissor: this.formBuilder.control(''),
			rg_uf: this.formBuilder.control(''),
			federado: this.formBuilder.control('N'),
			federacao_id: this.formBuilder.control(''),
			graduacao_id: this.formBuilder.control(''),
			cref_numero: this.formBuilder.control(''),
			cref_dt_expedicao: this.formBuilder.control(''),
			cref_dt_validade: this.formBuilder.control(''),
			observacao: this.formBuilder.control(''),
			estado_civil: this.formBuilder.control(''),
			estado_civil_id: this.formBuilder.control(''),
			tamanho_camisa: this.formBuilder.control(''),
			tamanho_agasalho: this.formBuilder.control(''),
			tamanho_calca: this.formBuilder.control(''),
			tamanho_calcado: this.formBuilder.control(''),
			tamanho_chinelo: this.formBuilder.control(''),
			modalidade: this.formBuilder.control(''),
			pis: this.formBuilder.control(''),
			grau_instrucao_id: this.formBuilder.control(''),
			grau_instrucao: this.formBuilder.control(''),
		});	
		this.tecnico_id = this.activatedRoute.snapshot.params['id'];
		this.pessoaService.getPessoaById('pessoa/tecnico',this.tecnico_id).subscribe(
		(tecnico) => {
			this.tecnico = tecnico.dados;
			this.pessoa_id = this.tecnico.pessoa_id;
			this.acesso = this.tecnico.acesso;
			if(this.tecnico.foto){
				this.thumb = this.tecnico.foto.thumb;
			}

			this.pessoaService.getPessoaById('pessoa',this.pessoa_id).subscribe(
				(success) =>{
					this.enderecos = success.dados.endereco;
					this.telefones = success.dados.telefone;
					this.idiomas = success.dados.idioma;
					this.contasBancarias = success.dados.conta_bancaria;
					this.anexos = success.dados.anexo;
				},
				(error) => {
					this.message = error.error.message;
				})


				this.detailForm.patchValue({
					id: this.tecnico.id,
					estrangeiro: this.tecnico.estrangeiro,
					passaporte: this.tecnico.passaporte,
					passaporte_dt_validade: this.tecnico.passaporte_dt_validade_br,
					cpf: this.tecnico.cpf,
					dt_cadastro: this.tecnico.dt_cadastro_br,
					dt_atualizacao: this.tecnico.dt_atualizacao_br,
					genero_id: this.tecnico.genero_id,
					genero: this.tecnico.genero,
					primeiro_nome: this.tecnico.primeiro_nome,
					ultimo_nome: this.tecnico.ultimo_nome,
					nome_completo: this.tecnico.nome_completo,
					apelido: this.tecnico.apelido,
					email: this.tecnico.email,
					rg: this.tecnico.rg,
					rg_uf: this.tecnico.rg_uf,
					rg_dt_emissao: this.tecnico.rg_dt_emissao_br,
					rg_emissor: this.tecnico.rg_emissor,
					nacionalidade: this.tecnico.nacionalidade,
					naturalidade: this.tecnico.naturalidade,
					foto: this.thumb,
					observacao: this.tecnico.observacao,
					federado: this.tecnico.federado == 'S' ? 'S' : 'N',
					federacao: this.tecnico.federacao,
					dt_nascimento: this.tecnico.dt_nascimento_br,
					graduacao: this.tecnico.graduacao,
					status: this.tecnico.status,
					website: this.tecnico.website,
					cref_numero: this.tecnico.cref_numero,
					cref_dt_expedicao: this.tecnico.cref_dt_expedicao_br,
					cref_dt_validade: this.tecnico.cref_dt_validade_br,
					estado_civil: this.tecnico.estado_civil,
					estado_civil_id: this.tecnico.estado_civil_id,
					tamanho_camisa: this.tecnico.tamanho_camisa,
					tamanho_agasalho: this.tecnico.tamanho_agasalho,
					tamanho_calca: this.tecnico.tamanho_calca,
					tamanho_calcado: this.tecnico.tamanho_calcado,
					tamanho_chinelo: this.tecnico.tamanho_chinelo,

					pis: this.tecnico.pis,
					grau_instrucao_id: this.tecnico.grau_instrucao_id,
					grau_instrucao: this.tecnico.grau_instrucao,
				});
				let modalidade = '';
				this.tecnico.modalidade.forEach( (v:any) => {
					modalidade += v.nome+';';
				});
				this.detailForm.patchValue({
					modalidade: modalidade
				})
			})
		}

	ngOnInit(){
		let t = JSON.parse(localStorage.getItem('CONFLogin'));
		if(!t.permissao.pessoa_tecnico.includes("CONSULTAR"))
			this.message = 'Você não possui permissão para executar esta ação'
	}
	
	
}